import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
import { Loading } from "../Loading";
import { Typography } from "../Typography";
import LeftIcon from "./LeftIcon";
import { Container } from "./styles";
export function Button({ size = "medium", type = "button", variant = "primary", target = "_self", disabled = false, loading = false, replaceHref = false, hasPermission = true, href, children, leftIcon, rightIcon, onClick, loadingProps, removeBlurAfterClick, ...props }) {
    const linkProps = href
        ? {
            as: Link,
            to: href,
            target,
            replace: replaceHref,
        }
        : null;
    const handleOnClick = (evt) => {
        if (disabled || !hasPermission || loading)
            return;
        onClick?.(evt);
        if (removeBlurAfterClick)
            evt?.currentTarget?.blur?.();
    };
    return (_jsxs(Container, { size: size, variant: variant, disabled: disabled || !hasPermission, "data-size": size, "data-variant": variant, "data-loading": loading, "data-detached-icon": leftIcon?.detached, type: type, onClick: handleOnClick, ...props, ...linkProps, children: [leftIcon && _jsx(LeftIcon, { ...leftIcon, disabled: disabled }), children && (typeof children === "string" ? _jsx(Typography, { children: children }) : children), rightIcon && _jsx(Icon, { ...rightIcon }), loading && (_jsx(Flex, { position: "absolute", top: "50%", left: "50%", className: "loading-icon", children: _jsx(Loading, { ...loadingProps }) }))] }));
}
//# sourceMappingURL=index.js.map